// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b31a14ee","311":"53187448","574":"a375eacb","709":"045f2013","909":"1db37776","954":"85c9e4fc","963":"96e1aee8","967":"b3003ba0"}[chunkId] + ".chunk.js";
};